import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequisitionSkillsComponent } from './requisition-skills.component';
import { AddEditCandidateSkillModule } from './add-edit-candidate-skill/add-edit-candidate-skill.module';
import { FormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
import { TooltipModule, TypeaheadModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [RequisitionSkillsComponent],
  imports: [
    CommonModule,
    AddEditCandidateSkillModule,
    FormsModule,
    NgxEditorModule,
    TypeaheadModule,
    TooltipModule
  ],
  exports: [RequisitionSkillsComponent],
  entryComponents: [RequisitionSkillsComponent]
})
export class RequisitionSkillsModule { }
